export const usdFormatter = new Intl.NumberFormat('en-US', {
  currency: 'USD',
  style: 'currency'
})

export const postalCodeRegex = /^\d{5}$/
export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const convertToCentValue = (centValue: number, currencyType: string): string => {
  switch (currencyType) {
    case 'USD':
    case 'EUR':
    case 'GBP':
    default:
      return (centValue * 100).toFixed(0)
  }
}

export const convertFromCentValue = (centValue: number, currencyType: string): number => {
  switch (currencyType) {
    case 'USD':
    case 'EUR':
    case 'GBP':
    default:
      return centValue / 100
  }
}

export const formatPercentage = (value: number): string => {
  return Intl.NumberFormat('en-us', {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
    style: 'percent'
  }).format(value)
}

export const toCamel = (s: string): string => (
  s.replace(/([-_][a-z])/ig, ($1) => (
    $1.toUpperCase()
      .replace('-', '')
      .replace('_', '')
  ))
)

export const toTitleCase = (str: string): string => (
  str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  )
)

export const insertAtPosition = ({ str, index, value }: { str: string, index: number, value: string }): string => {
  return str.substr(0, index) + value + str.substr(index)
}

export const stripCardFormatting = (str: string): string =>
  str
    .replace(/\D/g, '')
    .replace(/\s/g, '')

export function formatExpiration (expDate: string | undefined): string | undefined | null {
  if (expDate?.length === 4) {
    return `${expDate.slice(0, 2)}/${expDate.slice(2)}`
  }
}

export function formatUrl (base: string, params: { [key in string]: string }): string {
  const url = new URL(base)
  for (const [key, value] of Object.entries(params)) {
    url.searchParams.set(key, value)
  }
  return url.toString()
}
